import axios from 'axios';

// export const API_URL = `http://localhost:5001/api`;
export const APP_MAIN_URL =  window.location.hostname === 'localhost' ? `http://localhost:5001` : `https://${window.location.hostname}`;
export const API_URL = `${APP_MAIN_URL}/api`;

const $api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

$api.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return config;
});

$api.interceptors.response.use(
    response => response,
    error => {
        throw error;
    }
);

export default $api;